var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DuoyunDateRangePickElement_onClear, _DuoyunDateRangePickElement_onOpen, _DuoyunDateRangePickElement_getCurrentLabel;
import { adoptedStyle, customElement, attribute, emitter, globalemitter, property, boolattribute, state, } from '@mantou/gem/lib/decorators';
import { GemElement, html } from '@mantou/gem/lib/element';
import { createCSSSheet, css, classMap } from '@mantou/gem/lib/utils';
import { Time } from '../lib/time';
import { icons } from '../lib/icons';
import { theme } from '../lib/theme';
import { locale } from '../lib/locale';
import { isNotNullish } from '../lib/types';
import { commonHandle } from '../lib/hotkeys';
import { focusStyle } from '../lib/styles';
import { ContextMenu } from './menu';
import { pickerStyle } from './pick';
import './use';
import './date-range-panel';
import './button';
const style = createCSSSheet(css `
  :host {
    width: 18em;
  }
  .value {
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .placeholder {
    color: ${theme.describeColor};
  }
  .icon {
    display: flex;
  }
  .close,
  .clearable:hover .date {
    display: none;
  }
  .clearable:hover .close {
    display: inline-flex;
  }
`);
/**
 * @customElement dy-date-range-pick
 * @attr placeholder
 * @attr clearable
 * @attr disabled
 * @fires change
 * @fires clear
 */
let DuoyunDateRangePickElement = class DuoyunDateRangePickElement extends GemElement {
    constructor() {
        super();
        _DuoyunDateRangePickElement_onClear.set(this, (e) => {
            e.stopPropagation();
            this.clear(null);
        });
        _DuoyunDateRangePickElement_onOpen.set(this, () => {
            var _a;
            if (this.disabled)
                return;
            let v = undefined;
            const onChange = ({ detail, target }) => {
                const root = target.getRootNode();
                const button = root.querySelector('dy-button');
                button.disabled = false;
                v = detail;
            };
            const onSubmit = () => {
                if (isNotNullish(v)) {
                    this.change(v);
                    ContextMenu.close();
                }
            };
            const onQuick = (value) => {
                this.change(value);
                ContextMenu.close();
            };
            ContextMenu.open(html `
        <dy-date-range-panel @change=${onChange} .value=${this.value}></dy-date-range-panel>
        <style>
          .footer {
            margin-block-start: 2em;
            display: flex;
            justify-content: space-between;
          }
          .quick {
            display: flex;
            align-items: center;
            gap: 0.5em;
          }
          .quick-item {
            cursor: pointer;
          }
        </style>
        <div class="footer">
          <div class="quick">
            ${(_a = this.quickRanges) === null || _a === void 0 ? void 0 : _a.map(({ label, value }) => html `
                  <dy-action-text
                    class=${classMap({ 'quick-item': true })}
                    .active=${this.value === value}
                    @click=${() => onQuick(value)}
                  >
                    ${label}
                  </dy-action-text>
                `)}
          </div>
          <dy-button disabled @click=${onSubmit} small>${locale.ok}</dy-button>
        </div>
      `, {
                activeElement: this,
                width: '30em',
            });
        });
        _DuoyunDateRangePickElement_getCurrentLabel.set(this, (value) => {
            if (Array.isArray(value)) {
                return this.value.map((t) => new Time(t).format('YYYY-MM-DD')).join(' ~ ');
            }
            if (this.quickRanges) {
                const range = this.quickRanges.find((e) => value === e.value);
                return range === null || range === void 0 ? void 0 : range.label;
            }
        });
        this.mounted = () => {
            return () => this.active && ContextMenu.close();
        };
        this.render = () => {
            return html `
      <div class=${classMap({ value: true, placeholder: !this.value })}>
        ${this.value ? __classPrivateFieldGet(this, _DuoyunDateRangePickElement_getCurrentLabel, "f").call(this, this.value) : this.placeholder}
      </div>
      <div class=${classMap({ icon: true, clearable: this.clearable })}>
        <dy-use class="date" .element=${icons.date}></dy-use>
        <dy-use @click=${__classPrivateFieldGet(this, _DuoyunDateRangePickElement_onClear, "f")} class="close" .element=${icons.close}></dy-use>
      </div>
    `;
        };
        this.addEventListener('click', __classPrivateFieldGet(this, _DuoyunDateRangePickElement_onOpen, "f"));
        this.addEventListener('keydown', commonHandle);
        this.tabIndex = 0;
        this.internals.role = 'combobox';
    }
};
_DuoyunDateRangePickElement_onClear = new WeakMap(), _DuoyunDateRangePickElement_onOpen = new WeakMap(), _DuoyunDateRangePickElement_getCurrentLabel = new WeakMap();
__decorate([
    attribute
], DuoyunDateRangePickElement.prototype, "placeholder", void 0);
__decorate([
    boolattribute
], DuoyunDateRangePickElement.prototype, "clearable", void 0);
__decorate([
    boolattribute
], DuoyunDateRangePickElement.prototype, "disabled", void 0);
__decorate([
    state
], DuoyunDateRangePickElement.prototype, "active", void 0);
__decorate([
    property
], DuoyunDateRangePickElement.prototype, "value", void 0);
__decorate([
    property
], DuoyunDateRangePickElement.prototype, "quickRanges", void 0);
__decorate([
    globalemitter
], DuoyunDateRangePickElement.prototype, "change", void 0);
__decorate([
    emitter
], DuoyunDateRangePickElement.prototype, "clear", void 0);
DuoyunDateRangePickElement = __decorate([
    customElement('dy-date-range-pick'),
    adoptedStyle(style),
    adoptedStyle(pickerStyle),
    adoptedStyle(focusStyle)
], DuoyunDateRangePickElement);
export { DuoyunDateRangePickElement };
//# sourceMappingURL=date-range-pick.js.map